import { Location } from '../../Location.js';
import { TreeReference } from '../../TreeReference.js';
import { CalendarDate } from './CalendarDate.js';
import { schemaFactory } from './Factory.js';
const sharedCalendarEventProps = {
    id: schemaFactory.identifier,
    title: schemaFactory.string,
    date: CalendarDate,
    location: schemaFactory.optional(Location),
    description: schemaFactory.optional(schemaFactory.string),
    characters: schemaFactory.array(TreeReference),
};
export class GalaxyEvent extends schemaFactory.object('galaxy-event', {
    ...sharedCalendarEventProps,
    involvedFactions: schemaFactory.array(schemaFactory.string),
}) {
}
export class CampaignEvent extends schemaFactory.object('campaign-event', {
    ...sharedCalendarEventProps,
    campaign: TreeReference,
}) {
}
export class CharacterEvent extends schemaFactory.object('character-event', {
    ...sharedCalendarEventProps,
}) {
}
export const CalendarEvent = [GalaxyEvent, CampaignEvent, CharacterEvent];
//# sourceMappingURL=CalendarEvent.js.map